import React from "react";
import { useTranslation } from "react-i18next";

const WatchTimeRewards = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-orange-100 text-orange-600 text-xs font-bold px-3 py-1 rounded-full mb-4">
            {t("watchTime.badge")}
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            {t("watchTime.title")} <span className="text-orange-500">{t("watchTime.titleHighlight")}</span>
          </h2>
          <p className="max-w-2xl mx-auto text-gray-600 text-lg">
            {t("watchTime.subtitle")}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:border-orange-300 hover:shadow-lg transition text-center">
            <div className="text-5xl mb-4">🎮</div>
            <h3 className="font-bold text-xl text-gray-800 mb-2">{t("watchTime.playTitle")}</h3>
            <p className="text-gray-600 text-sm leading-relaxed">{t("watchTime.playDesc")}</p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:border-orange-300 hover:shadow-lg transition text-center">
            <div className="text-5xl mb-4">👨‍👩‍👧</div>
            <h3 className="font-bold text-xl text-gray-800 mb-2">{t("watchTime.approveTitle")}</h3>
            <p className="text-gray-600 text-sm leading-relaxed">{t("watchTime.approveDesc")}</p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:border-orange-300 hover:shadow-lg transition text-center">
            <div className="text-5xl mb-4">📺</div>
            <h3 className="font-bold text-xl text-gray-800 mb-2">{t("watchTime.watchTitle")}</h3>
            <p className="text-gray-600 text-sm leading-relaxed">{t("watchTime.watchDesc")}</p>
          </div>
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 bg-white border border-orange-200 rounded-full px-6 py-3 shadow-sm">
            <span className="text-2xl">🏆</span>
            <span className="text-sm font-semibold text-gray-700">{t("watchTime.tagline")}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WatchTimeRewards;
